module.exports = __webpack_public_path__ + "static/img/goods.25a87b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/common/img/goods.png
// module id = VZ2y
// module chunks = 37